<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <div className="animated">
            <b-card header-tag="header" footer-tag="footer">
              <h1>Mapa de Bodega</h1>
              <div>
                <b-form>
                  <b-row>
                    <b-col>
                      <label>Bodega</label>
                      <b-form-select
                        v-model="selected.room"
                        :plain="true"
                        :options="selectOptions.rooms"
                        value="Seleccione..."
                        value-field="id"
                        text-field="name"
                      >
                      </b-form-select>
                    </b-col>
                    <b-col>
                      <label>Estado</label>
                      <b-form-select
                        v-model="selected.state"
                        :plain="true"
                        :options="selectOptions.states"
                        value="Seleccione..."
                      >
                      </b-form-select>
                    </b-col>
                  </b-row>
                </b-form>
              </div>
              <hr />
              <v-server-table
                :url="url"
                :columns="columns"
                :options="options"
                :theme="theme"
                ref="table"
                id="dataTable"
              >
                <template slot="afterFilter">
                  <tr v-if="loading" class="VueTables__no-results">
                    <b-spinner
                      v-if="loading"
                      variant="primary"
                      class="ml-2 mt-1"
                      small
                      label="Small Spinner"
                    ></b-spinner>
                  </tr>
                </template>

                <template slot="state" slot-scope="props">
                  <div style="text-align: center">
                    <b-badge pill :variant="getBadge(props.row.state)">{{
                      props.row.state
                    }}</b-badge>
                  </div>
                </template>
              </v-server-table>
            </b-card>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { ServerTable, Event } from "vue-tables-2";
import numeral from "numeral";
import locales from "numeral/locales";

import JsonExcel from "vue-json-excel";
import moment from "moment";

Vue.component("downloadExcel", JsonExcel);

window.axios = require("axios");

Vue.use(ServerTable);
var d = new Date();

export default {
  name: "ListMaping",
  components: {
    ServerTable
  },
  mounted() {
    Event.$on("vue-tables.loading", () => {
      this.loading = true;
    });

    Event.$on("vue-tables.loaded", () => {
      this.loading = false;
    });
    this.loadRoom();
  },
  props: [],
  data() {
    return {
      loading: false,
      selected: {
        room: null,
        state: "TODOS"
      },
      selectOptions: {
        rooms: [],
        states: [
          { value: "TODOS", text: "TODOS" },
          { value: "DISPONIBLE", text: "DISPONIBLES" },
          { value: "OCUPADO", text: "OCUPADOS" }
        ]
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8"
          }
        ]
      ],
      json_fields: {
        Numero: "waybill"
      },
      columns: ["name", "room_name", "state", "pallet_quantity"],
      data: [],
      useVuex: false,
      theme: "bootstrap4",
      template: "default",
      options: {
        responseAdapter: function(resp) {
          const results = resp.data.results;
          const items = [];
          for (let key in results) {
            const item = results[key];
            items.push(item);
          }

          return {
            data: items,
            count: resp.data.count
          };
        },
        texts: {
          filter: "Filtrar:",
          filterBy: "Filtrar por {column}",
          count: " ",
          filterPlaceholder: "Buscar...",
          columns: "Columnas",
          limit: "Registros:"
        },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        debounce: 700,
        // columnsDropdown: true,
        filterByColumn: true,
        filterable: ["name"],
        headings: {
          name: "Posicion",
          room_name: "Bodega",
          state: "Estado",
          pallet_quantity: "Pallets"
        },
        sortable: [],
        sortIcon: {
          base: "fa",
          up: "fa-sort-asc",
          down: "fa-sort-desc",
          is: "fa-sort"
        },
        pagination: {
          dropdown: false,
          chunk: 10
        }
      },
      json_fields2: {
        Numero: "waybill.number",
        Embarque: "shipment.boarding_number",
        Vgm: {
          field: "vgm",
          callback: value => {
            return numeral(parseFloat(value)).format("0.00");
          }
        },
        "Planilla SAG": "sag_sheet",
        "Contraparte SAG": "sag_worker.get_full_name"
      }
    };
  },
  filters: {
    date_format(value) {
      return moment(value).format("DD-MM-YYYY HH:MM");
    }
  },
  computed: {
    url() {
      return (
        "/storage/position_list/?" +
        "&room=" +
        this.selected.room +
        "&state=" +
        this.selected.state
      );
    }
  },
  methods: {
    loadRoom() {
      this.$axios
        .get("/storage/room/")
        .then(res => {
          this.selectOptions.rooms = res.data.results;
          //this.selected.room = this.selectOptions.rooms[0].id;
        })
        .catch(error => console.log(error));
    },
    getBadge(state) {
      return state === "OCUPADO"
        ? "danger"
        : state === "DISPONIBLE"
        ? "success"
        : "light";
    }
  }
};
</script>

<style lang="scss">
#dataTable {
  width: 100%;
  margin: 0 auto;

  .VuePagination {
    text-align: center;
    justify-content: center;
  }

  .table td {
    padding: 0.3em;
  }

  .vue-title {
    text-align: center;
    margin-bottom: 10px;
  }

  .VueTables__search-field {
    display: flex;
  }

  .VueTables__search-field input {
    margin-left: 0.12rem;
  }

  .VueTables__limit-field {
    display: flex;
  }

  .VueTables__limit-field select {
    margin-left: 0.25rem !important;
  }

  .VueTables__table th {
    text-align: center;
    padding: 0.25rem;
  }

  .VueTables__child-row-toggler {
    width: 16px;
    height: 16px;
    line-height: 16px;
    display: block;
    margin: auto;
    text-align: center;
  }

  .VueTables__child-row-toggler--closed::before {
    content: "+";
  }

  .VueTables__date-filter {
    border: 1px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__number-field {
    border: 4px solid #ccc;
    padding: 6px;
    border-radius: 4px;
    cursor: pointer;
  }

  .VueTables__child-row-toggler--open::before {
    content: "-";
  }
}
</style>
